import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';

export interface MobileGlobalSearchContextValue {
  searchQuery: string;
  setSearchQuery: (query: string) => void;
  handleSearchChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleSearchClear: () => void;
}

const MobileGlobalSearchContext = createContext<MobileGlobalSearchContextValue | null>(null);

interface MobileGlobalSearchProviderProps {
  children: React.ReactNode;
}

export const MobileGlobalSearchProvider = ({ children }: MobileGlobalSearchProviderProps) => {
  const [searchQuery, setSearchQuery] = useState('');

  const handleSearchChange = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(event.target.value);
  }, []);

  const handleSearchClear = useCallback(() => {
    setSearchQuery('');
  }, []);

  const value = useMemo(
    () => ({
      searchQuery,
      setSearchQuery,
      handleSearchChange,
      handleSearchClear,
    }),
    [searchQuery, handleSearchChange, handleSearchClear],
  );

  return (
    <MobileGlobalSearchContext.Provider value={value}>
      {children}
    </MobileGlobalSearchContext.Provider>
  );
};

export function useMobileGlobalSearch(): MobileGlobalSearchContextValue {
  const context = useContext(MobileGlobalSearchContext);

  if (!context) {
    throw new Error('useMobileGlobalSearch doit être utilisé sous MobileGlobalSearchProvider');
  }

  return context;
}
